import React from "react";
import styles from "./WelcomeScreen.module.scss";
import { OwcTypography } from "@one/react";

const WelcomeScreen = ({ text = "You must login to view equipment" }) => {
  return (
    <div className={styles.welcomeScreenWrapper} data-testid="main-page-not-authenticated-with-no-error-by-backend">
      <OwcTypography style={{ color: "inherit" }} element="h2" variant="title2">
        Equipment Booking
      </OwcTypography>
      <OwcTypography style={{ color: "inherit" }} element="h2" variant="title2">
        Welcome
      </OwcTypography>
      <div className={styles.wrapTitle5}>
        <OwcTypography style={{ color: "inherit" }} element="h5" variant="title5">
          {text}
        </OwcTypography>
      </div>
    </div>
  );
};

export default WelcomeScreen;
